<!--
  -  TTTech nerve-management-system
  -  Copyright(c) 2021. TTTech Industrial Automation AG.
  -
  -  ALL RIGHTS RESERVED.
  -
  -  Usage of this software, including source code, netlists, documentation,
  -  is subject to restrictions and conditions of the applicable license
  -  agreement with TTTech Industrial Automation AG or its affiliates.
  -
  -  All trademarks used are the property of their respective owners.
  -
  -  TTTech Industrial Automation AG and its affiliates do not assume any liability
  -  arising out of the application or use of any product described or shown
  -  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
  -  make changes, at any time, in order to improve reliability, function or
  -  design.
  -
  -  Contact Information:
  -  support@tttech-industrial.com
  -
  -  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
  -
  -->

<template>
  <NerveDialog
    id="iiotProgressBarDialog"
    v-model="utilsStore.progressBarDialog"
    persistent
    scrollable
    max-width="500"
    @keydown.esc="close()"
  >
    <v-card class="progress-bar">
      <v-card-title id="iiotProgressBarDialogTitle">
        {{
          progress === 100
            ? $t('workloadVersion.progressBarDialog.savingWorkload')
            : $t('workloadVersion.progressBarDialog.uploadingWorkload')
        }}
      </v-card-title>
      <v-card-text>
        <div>
          <v-progress-linear v-if="progress < 100" determinate :model-value="progress" />
          <v-progress-linear v-if="progress === 100" indeterminate />
        </div>
      </v-card-text>

      <v-card-actions>
        <NerveButton
          id="iiotProgressBarDialogCancelButton"
          :text="$t('dialog.cancel')"
          :class="[{ 'visibility-hidden': !(progress < 100) }]"
          type-of-btn="close"
          size="normal"
          @click-event="close()"
        />
      </v-card-actions>
    </v-card>
  </NerveDialog>
</template>

<script setup>
import { computed } from 'vue';
import { NerveButton, NerveDialog } from '@nerve/ui-components';
import useUtilsStore from '@/store/modules/pinia/utils/_api_request_handler';
import useWorkloadDetailsStore from '@/store/modules/pinia/workload-details';
import useWorkloadVersionStore from '@/store/modules/pinia/workload-version';

/*
  Stores
*/
const utilsStore = useUtilsStore();
const workloadDetailsStore = useWorkloadDetailsStore();
const workloadVersionStore = useWorkloadVersionStore();

/*
  Computed
*/
const progress = computed(() =>
  workloadDetailsStore.selectedVersion ? workloadDetailsStore.progress : workloadVersionStore.progress,
);

/*
  Methods
*/
const close = () => {
  workloadDetailsStore.selectedVersion ? workloadDetailsStore.cancelRequest() : workloadVersionStore.cancelRequest();
  utilsStore.closeProgressBarDialog();
};
</script>
<style lang="scss" scoped>
.title-text {
  color: #fff;
}
.progress-bar {
  height: 220px !important;
}
</style>
